import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Skeleton, SkeletonStyle } from 'primeng/skeleton';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-skeleton',
  templateUrl: './m-skeleton.component.html',
  styleUrls: ['./m-skeleton.component.scss'],
  providers: [SkeletonStyle],
  imports: [Skeleton]
})
export class MSkeletonComponent extends Skeleton {
  // PrimeNG 20 applies root host class + style via
  // `host: { '[class]': "cn(cx('root'), styleClass)", '[style]': "containerStyle" }`. This wrapper
  // renders its OWN inner <p-skeleton>, so that metadata is inherited onto <m-skeleton> too —
  // duplicating the skeleton styling and sizing. Neutralize on the wrapper host; inner is unaffected.
  override cx(): string {
    return '';
  }

  override get containerStyle(): Record<string, unknown> | undefined {
    return undefined;
  }
}
